import React, { useContext } from 'react';
import { Modal } from 'antd';
import {Styled} from '../style';
import { FileViewHelper } from '../helper.view';
import { ModalTopbar } from '../components/Topbar';
import { FileList } from '../components/FileList';
import { FileContext } from '../Provider';
import { ModalFooter } from './Footer';

/**
 *
 *  Allows uploading files globally to bukku's file select
 *  PROPS:
 *  - visible: boolean --- (is file select modal visible)
 *  - mode: String --- 'multiple', 'single'. ('single' if unspecified)
 *  - onOk: submit files
 *  - onCancel: close file select
 *  - fileTypeFilter: specific file types to be shown in File select (IMAGES, VIDEO, PDF, EXCEL)
 *  - initFiles: [] --- files selected by parent (Contact / Transaction)
 *
 *  FileContext:
 *  - contextState: Object {} --- state of file select (refer inside FileContextProvider)
 *  - contextAction: Object {} --- actions of file select that deals with state management
 *                             --- (refer inside FileContextProvider)
 *  - contextProps: Object {} --- props of file select (same as props list above)
 */
export function FileSelectModal() {
    const fileContext = useContext(FileContext);
    console.log('render FileManager');

    const { contextState, contextAction, contextProps } = fileContext;
    const {
        // rowList,
        rowIdList,
        // search,
        // isNewSearch,
        // uploading,
        infiniteScrollFileList,
        newlyUploadedIds,
        hasMore,
        // currentPage,
        loading,
        isFirstLoad,
        // newlyUploadedIds,
    } = contextState;
    const {
        resetModal,
        // submitFile,
        // onSearch,
        // getUploadProps,
        onFileCardClick,
        handleInfiniteOnLoad,
    } = contextAction;
    const {
        visible,
        onOk,
        mode,
        fileTypeFilter,
        // isFileManager,
    } = contextProps;

    return (
        <Modal
            wrapClassName="modal-wrap-file-select"
            title={FileViewHelper.getModalTitle(mode, fileTypeFilter)}
            open={visible}
            onOk={onOk}
            onCancel={resetModal}
            destroyOnClose
            bodyStyle={{
                height: mode === 'multiple' ? 'calc(100% - 96px)' : 'calc(100% - 50px)',
            }}
            footer={<ModalFooter />}
            width="85%"
        >
            <Styled>
                <ModalTopbar />
                <FileList
                    fileList={infiniteScrollFileList}
                    rowIdList={rowIdList}
                    newlyUploadedIds={newlyUploadedIds}
                    hasMore={hasMore}
                    loading={loading}
                    isFirstLoad={isFirstLoad}
                    onFileCardClick={onFileCardClick}
                    handleInfiniteOnLoad={handleInfiniteOnLoad}
                    type="fileSelect"
                />
            </Styled>
        </Modal>

    );
}
